module.exports = __webpack_public_path__ + "static/img/da4.a01ee83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/da4.png
// module id = +D3y
// module chunks = 1